import React, { useState, useRef, useEffect } from "react"
import moment from 'moment'
import femaleSVG from '../../assets/images/male.svg'
import { IdeaAttachmentList } from "../../layout/ideaAttachmentList/ideaAttachmentList.component"
import { PostActions } from "../postActions/postActions.component"
import { Comments } from "../comments/comments.component"
import { CommentURL } from '../../utils/constant'
import { getComments } from "../../services/ideas.service"
export const Ideas = ({ ideaId, Name, Desc, CreatedAt, Attachments, hearts, likes, dislikes, comments, reactionId, reactionType, underReview }) => {

    const [showComments, setShowComments] = useState(false)
    const [commentsData, setShowCommentsData] = useState([])
    const [commentCount, setCommentCounts] = useState(comments)
    const commentRef = useRef(null)
    useEffect(() => {
        if (showComments) {
            commentRef.current.focus()
        }
    }, [showComments])

    const toggleComments = async (e) => {
        e.target.classList.toggle('text-primary')
        e.target.classList.toggle('opacity-50')
        if (!showComments) {
            await getCommentsData()
            setShowComments(true)
        } else {
            setShowComments(false)
        }

    }
    const getCommentsData = async () => {
        const { data } = await getComments(ideaId)
        setShowCommentsData(data);
    };

    return (
        <>
            <div className="row">
                <div className="col-lg-11">
                    <div className={`card ${underReview && 'border border-danger'}`}>
                        <div className="card-header pb-0">
                            <div className="d-flex justify-content-start align-items-center mb-1">
                                <div className="media">
                                    <div className="starshot-ring mr-1">
                                        <div className="avatar">
                                            <div className="text-icon font-lato">{Name[0]}</div>
                                        </div>
                                    </div>
                                    <div className="media-body my-auto">
                                        <p className="mb-0 font-lato">{Name}</p>
                                        <p className="mb-0 font-lato font-10 star-orange">{moment(CreatedAt).fromNow()}</p>
                                    </div>
                                </div>

                            </div>
                            {
                                underReview &&
                                <button type="button" className="btn btn-dark text-white rounded-10 font-11 font-lato waves-effect waves-float waves-light">
                                    Under Review
                                </button>
                            }
                        </div>
                        <div className="card-body mnh-125p">

                            <p className="card-text font-lato font-12">
                                {Desc}
                            </p>

                            <IdeaAttachmentList attachments={Attachments} />
                        </div>

                    </div>
                    {showComments && <Comments commentRef={commentRef} commentsCount={commentCount} setCommentCounts={setCommentCounts} data={commentsData} ideaId={ideaId} />}
                </div>
                <PostActions ideaId={ideaId} hearts={hearts} likes={likes} dislikes={dislikes} comments={commentCount} reactionId={reactionId} reactionType={reactionType} toggleComments={toggleComments} />
            </div>



        </>

    )
}